<template>
  <div class="content">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.content {
  min-height: calc(100% - 64px); //减头部高度
  background-color: #f7f6fd;
}
</style>

